import { useState, useEffect } from "react";
import { supabase } from "../supabaseClient";
import axios from "axios";
import toast from "react-hot-toast";
import { API_URL } from "../config";
import { Routes, Route, NavLink, useNavigate } from "react-router-dom";
import AnaSayfa from "./AnaSayfa";
import DipTarama from "./DipTarama";
import FvgTarama from "./FvgTarama";
import CapaTarama from "./CapaTarama";
import MsbTarama from "./MsbTarama";
import OteTarama from "./OteTarama";
import LikiditeTarama from "./LikiditeTarama";
import YardimSayfasi from "./YardimSayfasi";
import OBBBTarama from "./OBBBTarama";
import InducementTarama from "./InducementTarama";
import PDTarama from "./PDTarama";
import SMTTarama from "./SMTTarama";
import KillzoneTarama from "./KillzoneTarama";
import CokluTarama from "./CokluTarama";
import PuanlamaTahmin from "./PuanlamaTahmin";
import IslemPlanlama from "./IslemPlanlama";
import Alarmlarim    from "./Alarmlarim";
import Bildirimlerim from "./Bildirimlerim";
import TopdownCascadeTarama  from "./TopdownCascadeTarama";
import TopdownIzlemeListesi  from "./TopdownIzlemeListesi";
import KullaniciBilgileri from "./KullaniciBilgileri";
import DogrulukAnalizi from "./DogrulukAnalizi";
import GecmisSimulasyon from "./GecmisSimulasyon";
import KararMotoru from "./KararMotoru";
import HacimProfiliTarama  from "./HacimProfiliTarama";
import HacimAkisiTarama  from "./HacimAkisiTarama";
import DivergenceTarama  from "./DivergenceTarama";
import PiyasaRejimTarama  from "./PiyasaRejimTarama";
import SektorelRotasyonTarama  from "./SektorelRotasyonTarama";
import HaberDuyguTarama  from "./HaberDuyguTarama";
import BirlesikSkor  from "./BirlesikSkor";
import ModulAgirlikMerkezi  from "./ModulAgirlikMerkezi";
import WalkForwardOptimizasyon  from "./WalkForwardOptimizasyon";
import RiskDashboard  from "./RiskDashboard";
import Portfoy  from "./Portfoy";
import YatirimOneriMotoru  from "./YatirimOneriMotoru";
import BakimPaneli from "./BakimPaneli";
import SinyalYasamDongusu from "./SinyalYasamDongusu";
import LikiditeDerinlikTarama from "./LikiditeDerinlikTarama";
import KalibrasyonPaneli from "./KalibrasyonPaneli";
import BotPanosu from "./BotPanosu";


/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

export default function Dashboard() {
    const [profile, setProfile]       = useState(null);
    const [durum, setDurum]           = useState(null);
    const [sonuc, setSonuc]           = useState(null);
    const [yukleniyor, setYukleniyor] = useState(false);
    const [seciliMod, setSeciliMod]   = useState("BIST");
	const [bildirimSayisi, setBildirimSayisi] = useState(0);

    // Auth token al
	const getToken = async () => {
		const { data: { session } } = await supabase.auth.getSession();
		if (!session) return null;
		
		// Token 5 dakikadan az kaldıysa yenile
		if (session.expires_at * 1000 - Date.now() < 5 * 60 * 1000) {
			const { data } = await supabase.auth.refreshSession();
			return data.session?.access_token;
		}
		return session.access_token;
	};

	// Profil yükle
	useEffect(() => {
		const yukle = async () => {
			try {
				// Önce session'ı yenile
				const { data: { session }, error } = await supabase.auth.getSession();
				if (error || !session) {
					await supabase.auth.signOut();
					return;
				}

				// Token süresi dolduysa yenile
				if (session.expires_at * 1000 < Date.now()) {
					const { data: refreshed } = await supabase.auth.refreshSession();
					if (!refreshed.session) {
						await supabase.auth.signOut();
						return;
					}
				}

				const { data } = await supabase
					.from("profiles")
					.select("*, role_limits(*)")
					.single();
				setProfile(data);
			} catch (e) {
				console.log("Profil çekilemedi:", e.message);
			}
		};
		yukle();
		
		const bildirimYukle = async () => {
			const { data } = await supabase
				.from("notifications")
				.select("id", { count: "exact" })
				.eq("okundu", false);
			setBildirimSayisi(data?.length || 0);
		};
		// 30 saniyede bir kontrol
		setInterval(bildirimYukle, 30000);
		bildirimYukle();

	}, []);

	const [taramaTamamlandi, setTaramaTamamlandi] = useState(false);

	// Tarama durumunu periyodik sorgula
	useEffect(() => {
		const interval = setInterval(async () => {
			try {
				const token = await getToken();
				if (!token) return;
				const res = await axios.get(`${API_URL}/scan/durum`, {
					headers: { Authorization: `Bearer ${token}` }
				});
				setDurum(res.data);

				// Tarama çalışıyordu ve şimdi bitti
				if (res.data.calisıyor) {
					setTaramaTamamlandi(false);
				} else if (!res.data.calisıyor && !taramaTamamlandi && res.data.mesaj === "Tarama tamamlandı") {
					setTaramaTamamlandi(true);
					sonucGetir(token);
					toast.success("Tarama tamamlandı!");
				}
			} catch {}
		}, 3000);
		return () => clearInterval(interval);
	}, [taramaTamamlandi]);

    useEffect(() => {
        console.log("sonuc değişti:", sonuc ? "DOLU" : "BOŞ");
    }, [sonuc]);


	const taramaBaslat = async () => {
		setYukleniyor(true);
		setSonuc(null);  // ← ekle
		setTaramaTamamlandi(false);  // ← ekle
		try {
			const token = await getToken();
			await axios.post(`${API_URL}/scan/baslat?mod=${seciliMod}`, {}, {
				headers: { Authorization: `Bearer ${token}` }
			});
			toast.success("Tarama başlatıldı!");
		} catch (e) {
			console.log("Hata detayı:", e.response?.data);
			toast.error(e.response?.data?.detail || "Hata oluştu");
		}
		setYukleniyor(false);
	};

	const sonucGetir = async (token) => {
		try {
			const t = token || await getToken();
			console.log("sonucGetir çağrıldı, token:", t?.substring(0, 20));
			const res = await axios.get(`${API_URL}/scan/sonuc`, {
				headers: { Authorization: `Bearer ${t}` }
			});
			console.log("Sonuç tipi:", typeof res.data);
			console.log("Sonuç keys:", Object.keys(res.data));
			console.log("ozet var mı:", !!res.data.ozet);
			setSonuc(res.data);
		} catch (e) {
			console.log("Sonuç hatası:", e.response?.status, e.response?.data);
		}
	};

	const raporIndir = async () => {
		try {
			const token = await getToken();
			const res = await axios.get(`${API_URL}/scan/rapor-indir`, {
				headers: { Authorization: `Bearer ${token}` },
				responseType: "blob",  // ← dosya indirme için
			});
			// Dosyayı indir
			const url = window.URL.createObjectURL(new Blob([res.data]));
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", `borsa_rapor_${new Date().toLocaleDateString("tr-TR").replace(/\./g,"-")}.xlsx`);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
			toast.success("Rapor indiriliyor...");
		} catch (e) {
			toast.error("Rapor indirilemedi");
			console.log(e.response?.data);
		}
	};

    const navigate = useNavigate();
    const [menuAcik, setMenuAcik] = useState(false);
	const [kullaniciMenuAcik, setKullaniciMenuAcik] = useState(false);
	const [analizMenuAcik, setAnalizMenuAcik] = useState(false);
	const [dogrulamaMenuAcik, setDogrulamaMenuAcik] = useState(false);
	const [yatirimMenuAcik, setYatirimMenuAcik] = useState(false);
	const [otomasyonMenuAcik, setOtomasyonMenuAcik] = useState(false);
	const [bakimMenuAcik, setBakimMenuAcik] = useState(false);

    const cikis = async () => {
        await supabase.auth.signOut();
        toast.success("Çıkış yapıldı");
    };

	if (!profile || !profile.role_limits) {
		return (
			<div style={{ backgroundColor: '#121212', color: 'white', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<p>Profil ve Limit Bilgileri Yükleniyor...</p>
			</div>
		);
	}
	
    return (
        <div style={styles.layout}>
            {/* Sol menü */}
            <div style={styles.sidebar}>
				<NavLink to="/" style={{ ...styles.logo, textDecoration: "none", display: "block" }}>
					📈 Borsa Analiz
				</NavLink>
				{profile && (
					<div style={{ color: "white", fontWeight:"bold", fontSize: "14px", marginBottom: "1rem",
						paddingLeft: "0.5rem" }}>
						{profile.full_name || profile.email?.split("@")[0]} hoş geldin...
					</div>
				)}
				{bildirimSayisi > 0 && (
					<NavLink to="/bildirimlerim" style={{ textDecoration: "none" }}
						onClick={() => setBildirimSayisi(0)}>
						<div style={{ background: "#fef2f2", border: "1px solid #fca5a5",
							borderRadius: "6px", padding: "6px 10px", margin: "0 0 0.5rem",
							fontSize: "11px", color: "#dc2626", fontWeight: "600", cursor: "pointer" }}>
							🔔 {bildirimSayisi} yeni bildiriminiz var
						</div>
					</NavLink>
				)}
				<div style={styles.menuGrup}>
					<div style={styles.menuBaslik} onClick={() => setKullaniciMenuAcik(!kullaniciMenuAcik)}>
						👤 Kullanıcı İşlemleri {kullaniciMenuAcik ? "▲" : "▼"}
					</div>
					{kullaniciMenuAcik && (
						<div style={styles.altMenu}>
							<NavLink to="/kullanici-bilgileri" style={navStyle}>Kullanıcı Bilgileri</NavLink>
							<NavLink to="/kullanici-tercihleri" style={navStyle}>Kullanıcı Tercihleri</NavLink>
							<NavLink to="/topdown-izleme-listesi" style={navStyle}>👁 Topdown İzleme Listesi</NavLink>
							<NavLink to="/alarmlarim"    style={navStyle}>⏰ Alarmlarım</NavLink>
							<NavLink to="/bildirimlerim" style={navStyle}>🔔 Bildirimlerim</NavLink>
							<NavLink to="/portfoyum" style={navStyle}>💼 Portföyüm</NavLink>
				</div>
					)}
				</div>
                <div style={styles.menuGrup}>
                    <div
                        style={styles.menuBaslik}
                        onClick={() => setMenuAcik(!menuAcik)}
                    >
                        📊 Taramalar {menuAcik ? "▲" : "▼"}
                    </div>
                    {menuAcik && (
                        <div style={styles.altMenu}>
                            <NavLink to="/dip-tarama"   style={navStyle}>Dip Tarama</NavLink>
                            <NavLink to="/likidite-tarama"   style={navStyle}>Likidite Tarama</NavLink>
							<NavLink to="/fvg-tarama"   style={navStyle}>FVG Tarama</NavLink>
							<NavLink to="/capa-tarama"   style={navStyle}>Çapa Noktası Tarama</NavLink>
                            <NavLink to="/msb-tarama"   style={navStyle}>MSB Tarama</NavLink>
                            <NavLink to="/ote-tarama"   style={navStyle}>OTE Tarama</NavLink>
							<NavLink to="/obbb-tarama" style={navStyle}>OB & BB Tarama</NavLink>
							<NavLink to="/inducement-tarama" style={navStyle}>IDM Tarama</NavLink>
							<NavLink to="/pd-tarama" style={navStyle}>P/D Zone Tarama</NavLink>
							<NavLink to="/smt-tarama" style={navStyle}>SMT Tarama</NavLink>
							<NavLink to="/killzone-tarama" style={navStyle}>Killzone Tarama</NavLink>
							<NavLink to="/topdown-cascade" style={navStyle}>Topdown Cascade</NavLink>
							<NavLink to="/hacim-profili-tarama" style={navStyle}>Hacim Profili Tarama</NavLink>
							<NavLink to="/hacim-akisi-tarama" style={navStyle}>Hacim Akışı Tarama</NavLink>
							<NavLink to="/divergence-tarama" style={navStyle}>Divergence Tarama</NavLink>
							<NavLink to="/coklu-tarama" style={navStyle}>Çoklu Tarama</NavLink>
                        </div>
                    )}
                </div>
                <div style={styles.menuGrup}>
                    <div
                        style={styles.menuBaslik}
                        onClick={() => setAnalizMenuAcik(!analizMenuAcik)}
                    >
                        ⭐ Analiz & Puanlama {analizMenuAcik ? "▲" : "▼"}
                    </div>
                    {analizMenuAcik && (
                        <div style={styles.altMenu}>
                            <NavLink to="/islem-planlama"   style={navStyle}>📋 İşlem Planlama</NavLink>
                            <NavLink to="/puanlama-tahmin"   style={navStyle}>⭐ Puanlama & Tahmin</NavLink>
							<NavLink to="/karar-motoru"   style={navStyle}>🧭 Karar Motoru</NavLink>
							<NavLink to="/piyasa-rejim-analizi"   style={navStyle}>🌐 Piyasa Rejim Analizi</NavLink>
							<NavLink to="/sektorel-rotasyon"   style={navStyle}>🔄 Sektörel Güç Rotasyonu</NavLink>
							<NavLink to="/haber-duygu-analizi"   style={navStyle}>📰 Haber Duygu Analizi</NavLink>
							<NavLink to="/likidite-derinlik-tarama" style={navStyle}>💧 Likidite Derinlik</NavLink>
                        </div>
                    )}
                </div>
                <div style={styles.menuGrup}>
                    <div
                        style={styles.menuBaslik}
                        onClick={() => setDogrulamaMenuAcik(!dogrulamaMenuAcik)}
                    >
                        ✅ Doğrulama {dogrulamaMenuAcik ? "▲" : "▼"}
                    </div>
                    {dogrulamaMenuAcik && (
                        <div style={styles.altMenu}>
							<NavLink to="/dogruluk-analizi" style={navStyle}>✅ Doğruluk Analizi</NavLink>
                            <NavLink to="/gecmis-simulasyon"   style={navStyle}>🔮 Geçmiş Simülasyonu</NavLink>
                            <NavLink to="/modul-agirlik-merkezi"   style={navStyle}>⚖️ Modül Ağırlık Merkezi</NavLink>
                            <NavLink to="/birlesik-skor"   style={navStyle}>🧠 Birleşik Skor</NavLink>
                            <NavLink to="/walk-forward-optimizasyon"   style={navStyle}>🔬 Walk-Forward</NavLink>
                            <NavLink to="/risk-filtresi"   style={navStyle}>🛡 Risk Filtresi</NavLink>
                        </div>
                    )}
                </div>
                <div style={styles.menuGrup}>
                    <div
                        style={styles.menuBaslik}
                        onClick={() => setYatirimMenuAcik(!yatirimMenuAcik)}
                    >
                        🚀 Yatırım Karar Üreteci {yatirimMenuAcik ? "▲" : "▼"}
                    </div>
                    {yatirimMenuAcik && (
                        <div style={styles.altMenu}>
							<NavLink to="/sinyal-yasam-dongusu" style={navStyle}>🔄 Sinyal Yaşam Döngüsü</NavLink>
							<NavLink to="/kalibrasyon-paneli" style={navStyle}>📏 Skor Kalibrasyon Paneli</NavLink>
							<NavLink to="/yatirim-oneri-motoru" style={navStyle}>🎯 Yatırım Öneri Motoru</NavLink>
                        </div>
                    )}
                </div>
                <div style={styles.menuGrup}>
                    <div
                        style={styles.menuBaslik}
                        onClick={() => setOtomasyonMenuAcik(!otomasyonMenuAcik)}
                    >
                        💻 Otomasyon {otomasyonMenuAcik ? "▲" : "▼"}
                    </div>
                    {otomasyonMenuAcik && (
                        <div style={styles.altMenu}>
							<NavLink to="/bot-panosu" style={navStyle}>🤖 Bot Panosu</NavLink>
                        </div>
                    )}
                </div>
				<div style={styles.menuGrup}>
					<NavLink to="/yardim" style={styles.menuBaslik}>
						📚 Yardım ve Dokümantasyon
					</NavLink>
				</div>
				{profile?.role === "admin" && (
					<div style={styles.menuGrup}>
						<div style={styles.menuBaslik} onClick={() => setBakimMenuAcik(!bakimMenuAcik)}>
							🔧 Bakım {bakimMenuAcik ? "▲" : "▼"}
						</div>
						{bakimMenuAcik && (
							<div style={styles.altMenu}>
								<NavLink to="/bakim-paneli" style={navStyle}>⚙️ Bakım Paneli</NavLink>
							</div>
						)}
					</div>
				)}
                <button onClick={cikis} style={styles.cikisButon}>Çıkış Yap</button>
            </div>

            {/* İçerik */}
            <div style={styles.icerik}>
                <Routes>
					<Route path="/" element={<AnaSayfa />} />
					<Route path="/kullanici-bilgileri" element={<KullaniciBilgileri />} />
					<Route path="/topdown-izleme-listesi" element={<TopdownIzlemeListesi />} />
					<Route path="/alarmlarim"    element={<Alarmlarim />} />
					<Route path="/bildirimlerim" element={<Bildirimlerim />} />
					<Route path="/portfoyum" element={<Portfoy />} />
					<Route path="/dogruluk-analizi" element={<DogrulukAnalizi />} />
                    <Route path="/dip-tarama" element={<DipTarama />} />
					<Route path="/likidite-tarama" element={<LikiditeTarama />} />
                    <Route path="/fvg-tarama" element={<FvgTarama />} />
					<Route path="/capa-tarama" element={<CapaTarama />} />
					<Route path="/msb-tarama" element={<MsbTarama />} />
					<Route path="/ote-tarama" element={<OteTarama />} />
					<Route path="/obbb-tarama" element={<OBBBTarama />} />
					<Route path="/inducement-tarama" element={<InducementTarama />} />
					<Route path="/pd-tarama" element={<PDTarama />} />
					<Route path="/smt-tarama" element={<SMTTarama />} />
					<Route path="/killzone-tarama" element={<KillzoneTarama />} />
					<Route path="/coklu-tarama" element={<CokluTarama />} />
					<Route path="/topdown-cascade" element={<TopdownCascadeTarama />} />
					<Route path="/hacim-profili-tarama" element={<HacimProfiliTarama />} />
					<Route path="/hacim-akisi-tarama" element={<HacimAkisiTarama />} />
					<Route path="/divergence-tarama" element={<DivergenceTarama />} />
					<Route path="/islem-planlama" element={<IslemPlanlama />} />
					<Route path="/puanlama-tahmin" element={<PuanlamaTahmin />} />
					<Route path="/karar-motoru" element={<KararMotoru />} />
					<Route path="/piyasa-rejim-analizi" element={<PiyasaRejimTarama />} />
					<Route path="/sektorel-rotasyon" element={<SektorelRotasyonTarama />} />
					<Route path="/haber-duygu-analizi" element={<HaberDuyguTarama />} />
					<Route path="/likidite-derinlik-tarama" element={<LikiditeDerinlikTarama />} />
					<Route path="/gecmis-simulasyon" element={<GecmisSimulasyon />} />
					<Route path="/birlesik-skor" element={<BirlesikSkor />} />
					<Route path="/modul-agirlik-merkezi" element={<ModulAgirlikMerkezi />} />
					<Route path="/walk-forward-optimizasyon" element={<WalkForwardOptimizasyon />} />
					<Route path="/risk-filtresi" element={<RiskDashboard />} />
					<Route path="/sinyal-yasam-dongusu" element={<SinyalYasamDongusu />} />
					<Route path="/kalibrasyon-paneli" element={<KalibrasyonPaneli />} />
					<Route path="/yatirim-oneri-motoru" element={<YatirimOneriMotoru />} />
					<Route path="/bot-panosu" element={<BotPanosu />} />
					<Route path="/bakim-paneli" element={<BakimPaneli />} />
					<Route path="/yardim" element={<YardimSayfasi />} />
                </Routes>
            </div>
        </div>
    );
}

const navStyle = ({ isActive }) => ({
    display:"block", padding:"0.5rem 1rem 0.5rem 1.5rem",
    color: isActive ? "#2563eb" : "#d1d5db",
    textDecoration:"none", fontSize:"14px",
    background: isActive ? "rgba(37,99,235,0.1)" : "transparent",
    borderRadius:"6px",
});

const styles = {
    layout:      { display:"flex", minHeight:"100vh" },
    sidebar:     { width:"220px", background:"#1e3a5f", display:"flex",
                   flexDirection:"column", padding:"1rem", flexShrink:0 },
    logo:        { color:"white", fontWeight:"bold", fontSize:"16px",
                   padding:"0.5rem 0", marginBottom:"1.5rem" },
    menuGrup:    { marginBottom:"0.5rem" },
    menuBaslik:  { color:"#93c5fd", fontSize:"14px", fontWeight:"500",
                   padding:"0.5rem", cursor:"pointer", userSelect:"none",
                   display:"flex", justifyContent:"space-between", textDecoration:"none" },
    altMenu:     { display:"flex", flexDirection:"column", gap:"2px" },
    icerik:      { flex:1, background:"#f0f2f5", overflow:"auto" },
    cikisButon:  { marginTop:"auto", padding:"0.5rem", background:"#ef4444",
                   color:"white", border:"none", borderRadius:"8px", cursor:"pointer" },
};
